import Translate from './translate';

import * as log from 'loglevel';

class ConfigTranslate {

    constructor(config){
        this.config = config;
    }

    translate(){

        // for dynamic translation update we could listen to translation updates and trigger render
        // Translate.onUpdated((e) => this.render());
        try {

            let optionsJson = JSON.stringify(this.config.options);

            // IMPORTANT: also include variant options to decide that translations is required
            if(this.config.variantOption){
                optionsJson += JSON.stringify(this.config.variantOptions);
            }

            // check if translate is needed
            let keyIndex = optionsJson.indexOf('#');

            // EXCLUDE color codes from translation (maybe overkill but avoids the translation logic form being executed)
            if(keyIndex !== -1){
                // regex to only check 6 digits color codes  source: https://stackoverflow.com/a/8027444
                let colorRegex = /^#[0-9A-F]{6}$/i

                while(keyIndex !== -1){
                    let color = optionsJson.substr(keyIndex , 7);

                    if(colorRegex.test(color)){
                        log.trace('[config-translate] skipping color:', color);
                        keyIndex = optionsJson.indexOf('#', keyIndex + 1);
                    } else {
                        // not a color > translate key
                        break;
                    }
                }
            }

            // only if at least one key
            if(keyIndex !== -1){

                this._translateOptions(this.config.options);

                // NEW: variant options translate support
                if(this.config.variantOption){
                    this._translateOptions(this.config.variantOptions, true);
                }
                // NEW: always translate preview config if available (previous .config.preview check did not work when popup temporarily disables the preview)
                if(this.config.previewConfig && this.config.previewConfig.layers?.length){
                    this._translatePreview(this.config.previewConfig);
                }

                log.debug('[config-translate] translated options');
            } else {
                log.debug('[config-translate] skipped options translation');
            }


        } catch (e) {
            log.debug('[config-translate] error in translation', e);
        }

    }

    _translateOptions(options, variantOptions = false){

        // INFO: for dynamic update support we would need to store the source keys and detect translation changes to re-translate
        for (let i = 0; i < options.length; i++) {

            const option = options[i];

            if(option.label){
                option.label = Translate.translate(option.label);
            }

            // variant options name & value is fixed
            if(!variantOptions){
                if(option.name){
                    option.name = Translate.translate(option.name);
                }
                if(option.value){
                    option.value = Translate.translate(option.value);
                }
            }

            if(option.params.info){
                option.params.info = Translate.translate(option.params.info);
            }
            if(option.params.help){
                option.params.help = Translate.translate(option.params.help);
            }
            if(option.params.textHelp){
                option.params.textHelp = Translate.translate(option.params.textHelp);
            }
            if(option.params.placeholder){
                option.params.placeholder = Translate.translate(option.params.placeholder);
            }
            if(option.params.validationMsg){
                option.params.validationMsg = Translate.translate(option.params.validationMsg);
            }
            if(option.params.collapseLabel){
                option.params.collapseLabel = Translate.translate(option.params.collapseLabel);
            }
            if(option.params.textValueSelect){
                option.params.textValueSelect = Translate.translate(option.params.textValueSelect);
            }
            if(option.params.textSearchValues){
                option.params.textSearchValues = Translate.translate(option.params.textSearchValues);
            }
            if(option.params.button){
                option.params.button = Translate.translate(option.params.button);
            }
            if(option.params.atcText){
                option.params.atcText = Translate.translate(option.params.atcText);
            }
            if(option.params.textDiscountSave){
                option.params.textDiscountSave = Translate.translate(option.params.textDiscountSave);
            }
            if(option.params.textDiscountBuy){
                option.params.textDiscountBuy = Translate.translate(option.params.textDiscountBuy);
            }
            if(option.params.labelX){
                option.params.labelX = Translate.translate(option.params.labelX);
            }
            if(option.params.labelY){
                option.params.labelY = Translate.translate(option.params.labelY);
            }
            if(option.params.html){
                option.params.html = Translate.translate(option.params.html);
            }
            if(option.params.summaryTemplate){
                option.params.summaryTemplate = Translate.translate(option.params.summaryTemplate);
            }
            if(option.params.groupEditor?.button){
                option.params.groupEditor.button = Translate.translate(option.params.groupEditor.button);
            }

            // check values
            if(option.values){
                for (let j = 0; j < option.values.length; j++) {
                    const optionValue = option.values[j];
                    if(optionValue.value && !variantOptions){ // exclude variant options: fixed value
                        optionValue.value = Translate.translate(optionValue.value);
                    }
                    if(optionValue.text){
                        optionValue.text = Translate.translate(optionValue.text);
                    }
                }
            }

            // conditions
            if(option.conditions.length){
                this._translateConditions(option.conditions);
            }

            // nested
            if(option.options && option.options.length){
                this._translateOptions(option.options);
            }

        }
    }

    // preview translate only required for conditions & option references
    _translatePreview(previewConfig){

        let views = [previewConfig];
        // gallery translate all views
        if (previewConfig.gallery) {
            views.push(...previewConfig.views);
        }

        for (let i = 0; i < views.length; i++) {
            const view = views[i];
            this._translateLayers(view.layers);
        }
    }

    _translateLayers(layers){

        for (let i = 0; i < layers.length; i++) {

            const layer = layers[i];

            // translate option name references
            for (var param in layer.params) {
                if(layer.params.hasOwnProperty(param) && param.indexOf('option') !== -1){
                    layer.params[param] = Translate.translate(layer.params[param]);
                }
            }

            // default text
            if(layer.params.text){
                layer.params.text = Translate.translate(layer.params.text);
            }

            // conditions
            if(layer.conditions.length){
                this._translateConditions(layer.conditions);
            }

            // nested
            if(layer.layers && layer.layers.length){
                this._translateOptions(layer.layers);
            }
        }
    }

    _translateConditions(conditions){
        for (let i = 0; i < conditions.length; i++) {
            const condition = conditions[i];
            if(condition.field){
                condition.field = Translate.translate(condition.field);
            }
            if(condition.value){
                // value check if translation required
                if(condition.value.indexOf('#') !== -1){
                    // multi select OR condition requires split to translate
                    if(condition.value.indexOf(',') !== -1){
                        let values = condition.value.split(',');
                        for (let j = 0; j < values.length; j++) {
                            values[j] = Translate.translate(values[j]);
                        }
                        condition.value = values.join(',');
                    } else {
                        condition.value = Translate.translate(condition.value);
                    }
                }

            }
        }
    }

}

export default ConfigTranslate;